import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchCheckout } from "./api";
import { themeVars } from "../theme";
import PageLoader from "../../PageLoader";
import { checkoutTemplateFor } from "./index";

/**
 * Public course CHECKOUT page — route `/cs/:code/checkout`.
 *
 * Mirrors CourseLandingPage: fetches the checkout payload from the membership
 * admin API, applies the course's checkout theme as CSS variables on a wrapper,
 * and renders the matching CheckoutTemplate{N} (1-17). No auth.
 */
export default function CheckoutPage() {
  const { code } = useParams();
  const [state, setState] = useState({ status: "loading", data: null });

  useEffect(() => {
    let alive = true;
    setState({ status: "loading", data: null });
    fetchCheckout(code)
      .then((data) => alive && setState({ status: "ready", data }))
      .catch((err) => {
        if (!alive) return;
        setState({ status: err?.response?.status === 404 ? "notfound" : "error", data: null });
      });
    return () => {
      alive = false;
    };
  }, [code]);

  if (state.status === "loading") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-950">
        <PageLoader embedded page="Checkout" primary="#34D399" />
      </div>
    );
  }

  if (state.status === "notfound") {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-gray-950 px-4 text-center">
        <h1 className="text-3xl font-bold text-white">Checkout not found</h1>
        <p className="mt-2 text-sm text-gray-400">This checkout link is invalid or no longer available.</p>
      </div>
    );
  }

  if (state.status === "error") {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-gray-950 px-4 text-center">
        <h1 className="text-2xl font-bold text-white">Something went wrong</h1>
        <p className="mt-2 text-sm text-gray-400">Couldn’t load this checkout. Please try again.</p>
      </div>
    );
  }

  const { data } = state;
  const Template = checkoutTemplateFor(data.template_id);
  const vars = themeVars({ primary: data.primary, btnText: data.btnText, footerBg: data.footerBg });

  return (
    <div style={vars}>
      <Template data={data} code={code} />
    </div>
  );
}
